import React, { Component } from "react";

class ParticipantStream extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			currentUserData: JSON.parse(localStorage.getItem('userData')),
			allowRecalibration: JSON.parse(localStorage.getItem('recalibrationHidden')).value ? false : true
		}
	}
 
	componentDidMount(){
		window.closedStreamByClick = false;
		window['disableRecabToggle'] = this.disableRecabToggle;
		window.$Any('#recalibrationToggle input').prop("checked", this.state.allowRecalibration);
	}
	
	showHideStream=()=>{	
		var isOpenStreamVar = this.props.openMyStream;
		isOpenStreamVar = !isOpenStreamVar;
		
		window.closedStreamByClick = !isOpenStreamVar;
				
		this.props.updateStateFromChild({openMyStream: isOpenStreamVar});
	}
	
	switchRecalibrationToggle=()=>{
		var toggleValue = this.state.allowRecalibration ? false : true;
		if ( toggleValue )
			{
				this.setState({
					allowRecalibration: toggleValue
				},()=>{console.log('toggleis --->', this.state.allowRecalibration); this.props.recalibrationPopupAction(false)});
			}
		else
			{
				this.props.showRecalibrationPopup();
			}
	}
	
	disableRecabToggle=()=>{
		this.setState({
			allowRecalibration: false
		},()=>{console.log('toggleis 222 --->', this.state.allowRecalibration);});
	}
	
	render() {
		return (
			<div className="stream_container" id="mine_stream">
				{ window['hasConeScript'] && window['calculatingCalledAR'] && 
					<div id="recalibrationToggle" className="stream_inner menu_hidden_item">
						<div className="recab_title">Recalibration</div>
						<label className="switch">
							<input type="checkbox" checked={this.state.allowRecalibration} onChange = {this.switchRecalibrationToggle} />
							<span className="slider round"></span>
						</label>
					</div>
				}
				<div></div>
				<div className={"stream_inner menu_hidden_item " + ( (this.props.openMyStream || !window['cameraFoundStatus']) ? "d-none" : "" ) + (window['zoomedOption'] == 2 ? " stream_inner_zoomed" : "") } onClick={this.showHideStream}>Show stream
					<div className="open_arrow"></div>
				</div>
				<div id="my_stream_main"  className={"open_stream_inner " + ( (!this.props.openMyStream || !window['cameraFoundStatus']) ? "d-none" : "" ) }>
					<div className="hide_stream_text" onClick={this.showHideStream}>Hide your stream
						<div className="close_arrow"></div>
					</div>
					<div className="cam_container">
						<div className="cam_stream" id="mystream">
							<div className="participant_name_container">
								<div className="participant_name" id="stream_user_name">Me</div>
							</div>
							<div className="zoomPartStreamHolder" id="my_view_part">
								<div className="control_icon zoom_icon"></div>
							</div>
						</div>
						<div className="cam_stream d-none" id="hostmystream">
							{ (this.state.currentUserData.sessionData.replayClassId > 0 || this.state.currentUserData.sessionData.ondemandId > 0) &&
								<video id="replayClassVideoSwap" className="replay_video"></video>
							}
							<div className="participant_name_container">
								<div className="participant_name" id="stream_user_name_host">Me</div>
							</div>
							<div className="zoomPartStreamHolder" id="my_view_part_me">
								<div className="control_icon zoom_icon"></div>
							</div>
						</div>
					</div>
				</div>
			</div>		
	)}
}
export default ParticipantStream;
